import React, { ReactElement, useContext } from "react";
import {
  ComponentSingleStyleConfig,
  Tooltip,
  useStyleConfig,
} from "@chakra-ui/react";
import { TipDelayContext } from "../../../contexts/TipDelayContext";
import {
  ComponentStyleProps,
  componentStylePropsOf,
} from "../../../lib/styles/props/component-style-props";

export type CMTooltipProps = {
  tooltipLabel?: string;

  tooltipBackgroundColor?: string;

  /**
   * ツールチップの表示位置に使用
   */
  placement?:
    | "auto-start"
    | "auto"
    | "auto-end"
    | "top-start"
    | "top"
    | "top-end"
    | "right-start"
    | "right"
    | "right-end"
    | "bottom-start"
    | "bottom"
    | "bottom-end"
    | "left-start"
    | "left"
    | "left-end";

  children: ReactElement;
} & ComponentStyleProps;

/**
 * ツールチップを表示するコンポーネント
 */
export const CMTooltip = ({
  tooltipLabel,
  tooltipBackgroundColor,
  placement = "top",
  children,

  sx,
  ...rest
}: CMTooltipProps) => {
  const styles = useStyleConfig("CMTooltipStyles");

  const tipDelay = useContext(TipDelayContext);

  return (
    <Tooltip
      hasArrow
      label={tooltipLabel}
      placement={placement}
      backgroundColor={tooltipBackgroundColor}
      openDelay={tipDelay.sm}
      sx={{ ...styles, ...sx }}
      {...rest}
    >
      {children}
    </Tooltip>
  );
};

export const CMTooltipStyles: ComponentSingleStyleConfig = {
  baseStyle: {
    w: "fit-content",
    color: "gray.900",
  },
};
